import {mapGetters} from "vuex";

/**
 * adds data and computed properties for prefilling watchlist selection fields
 */
export default {
	data() {
		return {
			selectedCustomer: null,
			selectedWatchlist: null,
			newPrice: 0,
			newDescription: '',
		}
	},
	computed: {
		...mapGetters(['user', 'watchlist', 'displayedWatchlist']),
		presetCustomerName() {
			return this.selectedCustomer ? this.selectedCustomer.Account_Name : '';
		},
		presetWatchlistName() {
			return this.selectedWatchlist ? this.selectedWatchlist.name : '';
		},
		disableSave() {
			if (this.user.zohoAuthenticated) {
				return !(this.selectedWatchlist && this.selectedCustomer);
			} else {
				return !this.selectedWatchlist;
			}
		}
	},
	mounted() {
		if (this.watchlist && !this.watchlist.dynamic && (!this.displayedWatchlist || this.watchlist.uid !== this.displayedWatchlist.uid || this.$route.name !== 'watchlistDetail')) {
			this.selectedWatchlist = this.watchlist;

			if (this.user.zohoAuthenticated && this.watchlist.customerName && this.watchlist.zohoCustomer) {
				this.selectedCustomer = {
					Account_Name: this.watchlist.customerName,
					entityId: this.watchlist.zohoCustomer
				}
			}
		}
	},
}